import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import userFilter from "../../../hooks/filter/useFilter";
import "./FilterNeighbourhood.scss";
import useCountry from "../../../hooks/config/useConfig";
import { Department, Zone } from "../../../interfaces/locations";


export const FilterNeighbourhood = ({estate, activeParent, setActiveParent, setCounter }: { estate : Department, activeParent: boolean, setActiveParent: Function, setCounter: Function }) => {
  const { filterState, setFilter } = userFilter();
  const { country } = useCountry();
  const [searchParams] = useSearchParams();
  const [neighbourhoods, setNeighbourhoods] = useState<Zone[]>([]);
  const [activeObject , setActiveObject] = useState<{[key:string]: boolean}>({});


  useEffect(() => {

    const filteredNeighbourhoods = estate.zones

    setNeighbourhoods(filteredNeighbourhoods)

  }, [estate])

  // Compute active state from search tags (names) to reflect UI checks
  useEffect(() => {
    const searchTags = Array.isArray(filterState.search) ? filterState.search.map(s => s.toLowerCase()) : []
    let objectA : {[key:string]: boolean} = {}
    neighbourhoods.forEach(fn=>{
      const isTagged = searchTags.includes((fn.name || '').toLowerCase())
      objectA[fn.id] = isTagged || !!activeParent
    })
    setActiveObject(objectA)
  }, [neighbourhoods, filterState.search, activeParent])

  useEffect(()=>{
    setCounter(document.querySelectorAll(`.parent-estate-${estate.id} .neighbourhood-check .form-check-input:checked`).length)
    
  },[activeObject])


  const dropdowns = neighbourhoods.map((neighbourhood) => {

    const handleChange = (e: any) => {
      // Always manage neighbourhood as search tag only
      const currentSearch = Array.isArray(filterState.search) ? [...filterState.search] : [];
      const name = (neighbourhood.name || '').toString();

      if (!activeObject[neighbourhood.id]) {
        // selecting
        if (name && !currentSearch.map(s => s.toLowerCase()).includes(name.toLowerCase())) {
          currentSearch.push(name);
        }
      } else {
        // deselecting
        const lower = name.toLowerCase();
        const filteredTags = currentSearch.filter(t => t.toLowerCase() !== lower);
        currentSearch.length = 0;
        currentSearch.push(...filteredTags);
      }

      setFilter({ 
        search: currentSearch.length > 0 ? currentSearch : undefined,
        neighbourhood: undefined,
        location: undefined,
        commune: undefined
      })

    };

    return (
      <div key={'neigh-' + neighbourhood.id} className="neighbourhood-check d-flex py-1 d-flex align-items-center px-2 py-2 rounded-1 text-black" >
        <Form.Check id={`neighbourhood-${neighbourhood.id}`} className="me-2 d-flex align-items-center" checked={activeObject[neighbourhood.id] || false} readOnly onChange={handleChange}
          label={`${country === "CL" ? 'Comuna' : ''} ${neighbourhood.name}`} />
      </div>
    )

  });

  return (
    <>
      {dropdowns}
    </>
  );
};


